/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import TransactionsContainer from './dashboard/TransactionsContainer';
import TransactionContainer from './transaction/container/ReceiveFundContainer';

function ReceiveFundRoutes({ match }) {
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Receive Fund</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/receive-fund"
          >
            Dashboard
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/receive-fund/transaction"
          >
            Transaction
          </NavLink>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={TransactionsContainer}
          />
          <Route
            path={`${match.path}/transaction`}
            component={TransactionContainer}
          />
        </Switch>
      </div>
    </>
  );
}

ReceiveFundRoutes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(ReceiveFundRoutes);
